import { Check, Lock } from "lucide-react";
import { STAGES, STAGE_META, stagePct } from "@/lib/realestateConstants";

export const StageStepper = ({ property, active, onSelect }) => {
  const currentIdx = STAGES.indexOf(property.stage);
  const hasBuyer = !!property.buyer?.name?.trim();
  return (
    <div className="grid grid-cols-4 gap-2" data-testid="stage-stepper">
      {STAGES.map((s, i) => {
        const meta = STAGE_META[s];
        const pct = s === "vendido" ? (currentIdx === 3 ? 100 : 0) : stagePct(property.progress?.[s]);
        const reached = i <= currentIdx;
        const locked = s === "postventa" && !hasBuyer && currentIdx < 2;
        const isActive = active === s;
        return (
          <button key={s} onClick={() => onSelect(s)} data-testid={`stage-step-${s}`}
            className={`text-left rounded-xl border p-3 space-y-2 transition-all ${isActive ? "border-primary ring-2 ring-primary/20" : "hover:border-primary/40"} ${reached ? "bg-card" : "bg-secondary/40"}`}>
            <div className="flex items-center gap-2">
              <span className={`h-6 w-6 rounded-full flex items-center justify-center text-[11px] font-bold ${reached ? "text-white" : "bg-secondary text-muted-foreground"}`}
                style={reached ? { backgroundColor: meta.color } : undefined}>
                {i < currentIdx ? <Check size={13} /> : locked ? <Lock size={11} /> : i + 1}
              </span>
              <span className={`text-sm font-semibold ${reached ? "" : "text-muted-foreground"}`}>{meta.label}</span>
              {s === property.stage && <span className="ml-auto text-[10px] uppercase tracking-wider font-bold" style={{ color: meta.color }}>Actual</span>}
            </div>
            {s !== "vendido" && (
              <div className="space-y-1">
                <div className="h-1.5 rounded-full bg-primary/10 overflow-hidden"><div className="h-full transition-all" style={{ width: `${pct}%`, backgroundColor: meta.color }} /></div>
                <p className="text-[11px] text-muted-foreground">{property.progress?.[s]?.required_done || 0}/{property.progress?.[s]?.required_total || 0} obligatorios · {pct}%</p>
              </div>
            )}
            {locked && <p className="text-[11px] text-amber-700">Requiere comprador real</p>}
          </button>
        );
      })}
    </div>
  );
};
